/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as MakeOfferPageLoader } from './MakeOfferPage/MakeOfferPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as RequestQuotePageLoader } from './RequestQuotePage/RequestQuotePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as DashboardPageLoader } from './DashboardPage/DashboardPage.duck';
import { loadData as SchedulePageLoader } from './SchedulePage/SchedulePage.duck';
import { loadData as NewAuthPageLoader } from './NewAuthPage/NewAuthPage.duck';
import { loadData as VendorDashboardPageLoader } from './VendorDashboardPage/VendorDashboardPage.duck';
import { loadData as ActivityDetailPageLoader } from './ActivityDetailPage/ActivityDetailPage.duck';
import { loadData as CampScoutPageLoader } from './CampScoutPage/CampScoutPage.duck';
import { loadData as TravelSettingsPageLoader } from './TravelSettingsPage/TravelSettingsPage.duck';
import { loadData as ProvidersPageLoader } from './ProvidersPage/ProvidersPage.duck';
import { loadData as EditActivityPageLoader } from './EditActivityPage/EditActivityPage.duck';
import { loadData as CreateSessionPageLoader } from './CreateSessionPage/CreateSessionPage.duck';
import { loadData as CreateActivityPageLoader } from './CreateActivityPage/CreateActivityPage.duck';
import { loadData as VendorSessionsPageLoader } from './VendorSessionsPage/VendorSessionsPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    MakeOfferPage: {
      loadData: MakeOfferPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    RequestQuotePage: {
      loadData: RequestQuotePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    DashboardPage: {
      loadData: DashboardPageLoader,
    },
    SchedulePage: {
      loadData: SchedulePageLoader,
    },
    NewAuthPage: {
      loadData: NewAuthPageLoader,
    },
    VendorDashboardPage: {
      loadData: VendorDashboardPageLoader,
    },
    VendorSessionsPage: {
      loadData: VendorSessionsPageLoader,
    },
    ActivityDetailPage: {
      loadData: ActivityDetailPageLoader,
    },
    CampScoutPage: {
      loadData: CampScoutPageLoader,
    },
    TravelSettingsPage: {
      loadData: TravelSettingsPageLoader,
    },
    ProvidersPage: {
      loadData: ProvidersPageLoader,
    },
    EditActivityPage: {
      loadData: EditActivityPageLoader,
    },
    CreateSessionPage: {
      loadData: CreateSessionPageLoader,
    },
    CreateActivityPage: {
      loadData: CreateActivityPageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
